<template>
  <div>
    <div class="row">
      <div class="col-8">
        <b-form-input v-model="code" :placeholder="$t('taxCodePlaceholder')" @keyup.enter="lookup"></b-form-input>
      </div>
      <div class="col-4">
        <button :disabled="!code || loading" @click="lookup" class="btn btn-primary ml-2">
          <b-spinner v-if="loading" small></b-spinner>
          <span v-else>{{ $t('search') }}</span>
        </button>
      </div>
    </div>

    <div v-if="warning" class="alert alert-warning small mt-3 mb-0">{{ warning }}</div>

    <div v-if="result" class="mt-3">
      <p class="mb-1"><b>{{ $t('companyName') }}: </b><span>{{ result.name || $t('na') }}</span></p>
      <p v-if="result.shortName" class="mb-1"><b>{{ $t('shortName') }}: </b><span>{{ result.shortName }}</span></p>
      <p v-if="result.internationalName" class="mb-1"><b>{{ $t('internationalName') }}: </b><span>{{ result.internationalName }}</span></p>
      <p class="mb-1"><b>{{ $t('address') }}: </b><span>{{ result.address || $t('na') }}</span></p>
      <p class="mb-1">
        <b>{{ $t('status') }}: </b>
        <span class="badge" :class="isActive ? 'badge-primary' : 'badge-danger'">{{ result.status || $t('na') }}</span>
      </p>
      <small class="text-muted">{{ $t('taxCodeSource') }}</small>
    </div>
  </div>
</template>
<script>
import TaxCodeLookup from '@/mixins/TaxCodeLookup';

export default {
  mixins: [TaxCodeLookup],
  data() {
    return {
      code: null,
      loading: false,
      warning: null,
      result: null,
    };
  },
  computed: {
    isActive() {
      return this.result && this.result.status && this.result.status.includes('đang hoạt động');
    },
  },
  methods: {
    async lookup() {
      if (!this.code || !this.code.trim()) return;
      this.warning = null;
      this.result = null;
      this.loading = true;
      const res = await this.lookupTaxCode(this.code);
      this.loading = false;
      if (!res.ok) {
        this.warning = res.message;
        return;
      }
      this.result = res.data;
    },
  },
  i18n: {
    messages: {
      en: {
        taxCodePlaceholder: 'Enter business tax code (10 digits)',
        companyName: 'Company name',
        shortName: 'Short name',
        internationalName: 'International name',
        address: 'Address',
        status: 'Status',
        taxCodeSource: 'Source: General Department of Taxation (via VietQR). Data may be delayed a few days.',
        na: 'N/A',
      },
      vi: {
        taxCodePlaceholder: 'Nhập mã số thuế doanh nghiệp (10 số)',
        companyName: 'Tên công ty',
        shortName: 'Tên viết tắt',
        internationalName: 'Tên quốc tế',
        address: 'Địa chỉ',
        status: 'Trạng thái',
        taxCodeSource: 'Nguồn: Tổng cục Thuế (qua VietQR). Dữ liệu có thể trễ vài ngày.',
        na: 'Không có',
      },
    },
  },
};
</script>
